<template>
  <search from="category" ref="search_comp">
    <div id="vmss_search_form_component" class="vmss_search">
   	<div class="search advice-search grid-d centr-align">
      <img src="/static/css/images/acc/search.png" class="icon-position"> 
      <input type="text" class="form-control input-sm " maxlength="64" v-model='search_query' @click='openDropdown' @keydown.enter="search_terms" placeholder="Search website" />
      <div class="search-button orng-wte-c">
        <button type="submit" class="btn btn-primary btn-sm" @click='search_terms'>SEARCH</button>
      </div>
  	</div>
    </div>
  </search>
</template>

<script>
import { LoopingRhombusesSpinner } from 'epic-spinners'
import axios from 'axios';

  export default {
    name: 'acc-search',
    components: {
      LoopingRhombusesSpinner,
    },
    data(){
      return {
        search_query:'',
        previous_search_term: null,
        show_dropdown: false,
        search_results: [
        ]
      }
    },
    methods: {
      search_terms: function(){
        let search_query = this.search_query;
        if (!search_query) {
          return false;
        }
        this.search_query = '';
        this.search_results = [];

       var i = this.$router.push({path: `/search?keyword=${(search_query)}&page=1`});
      },
      noCoverImage: function(event){
        event.target.src = '/static/images/acc/No_Image_Available.jpg';
      },
      clickOutside: function(){
        this.show_dropdown = false;
      },       
      openDropdown: function(){
        if(this.search_query.length > 0 && this.search_results.length > 0){
          this.show_dropdown = true;
        }
      }
    },
    computed: {
      sub_search: function(){

        // this function returns 10 objects that are going to be rendered in the results html

        let term = this.search_query;

        let result = this.search_results.filter((item)=>{
          return Object.keys(item).some((key)=>{
            try {
              return item[key].toLowerCase().includes(term.toLowerCase());
            } catch (error) {
              console.log(error);
            }
          });
        });
        result.splice(10);
        return result;
      }
    },
     watch: {
      search_query: function(value){
        // This function does a request to the backend after the user types 4 letters in the search bar.
        // The search_results variable is set to [] only when the user deletes his previous search term
        let self = this;
        if(value.length >= 4 && self.search_results.length < 1){
          self.show_dropdown = true;
          axios.get('/search_books/', {
            params:{
              'search_query': value
            }
          }).then(function(data){
            self.search_results = data.data.results;
            // if there are no results the dropdown should be shown for one 1sec for the ux and then close
            if(self.search_results.length == 0){
              setTimeout(() => {
                self.show_dropdown = false;
              }, 1000);
            }
          });
        }else if(value.length < 4){
          self.search_results = [];
        }
      }
    }
}
</script>



